import { AppBar as MuiAppBar, Toolbar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuButton from "./MenuButton";

export default function AppBar() {
  const navigate = useNavigate();
  return (
    <MuiAppBar
      component="nav"
      color="primary"
      position="static"
      sx={{ boxShadow: 0 }}
    >
      <Toolbar>
        <MenuButton />
        <Typography
          variant="h4"
          fontWeight={700}
          ml={1}
          onClick={() => navigate("/")}
          sx={{
            ":hover": {
              cursor: "pointer",
            },
          }}
        >
          قانوني
        </Typography>
      </Toolbar>
    </MuiAppBar>
  );
}
